import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** Опций бесконечного скролирования. */
let DxInfiniteScrollOptions = class DxInfiniteScrollOptions {
    /** Опций бесконечного скролирования. */
    constructor() {
        /** Размер блока данных, который фетчится при скролировании. */
        this._initialRowCount = 100;
        /** Сколько блоков данных держать в кэше. */
        this._maxBlocksInCache = 2;
    }
    get initialRowCount() {
        return this._initialRowCount;
    }
    set initialRowCount(value) {
        this._initialRowCount = value;
    }
    get maxBlocksInCache() {
        return this._maxBlocksInCache;
    }
    set maxBlocksInCache(value) {
        this._maxBlocksInCache = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "initialRowCount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxInfiniteScrollOptions.prototype, "_initialRowCount", void 0);
tslib_1.__decorate([
    jsonMember({ name: "maxBlocksInCache", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxInfiniteScrollOptions.prototype, "_maxBlocksInCache", void 0);
DxInfiniteScrollOptions = tslib_1.__decorate([
    jsonObject
], DxInfiniteScrollOptions);
export { DxInfiniteScrollOptions };
